// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file questionnaire/common/v1/questionnaire_status.proto (package questionnaire.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file questionnaire/common/v1/questionnaire_status.proto.
 */
export const file_questionnaire_common_v1_questionnaire_status: GenFile = /*@__PURE__*/
  fileDesc("CjJxdWVzdGlvbm5haXJlL2NvbW1vbi92MS9xdWVzdGlvbm5haXJlX3N0YXR1cy5wcm90bxIXcXVlc3Rpb25uYWlyZS5jb21tb24udjEq5wEKE1F1ZXN0aW9ubmFpcmVTdGF0dXMSJAogUVVFU1RJT05OQUlSRV9TVEFUVVNfVU5TUEVDSUZJRUQQABIgChxRVUVTVElPTk5BSVJFX1NUQVRVU19PTkdPSU5HEAESIgoeUVVFU1RJT05OQUlSRV9TVEFUVVNfQ09NUExFVEVEEAISIAocUVVFU1RJT05OQUlSRV9TVEFUVVNfRVhQSVJFRBADEh4KGlFVRVNUSU9OTkFJUkVfU1RBVFVTX0RSQUZUEAQSIgoeUVVFU1RJT05OQUlSRV9TVEFUVVNfU1VCTUlUVEVEEAVCgAIKG2NvbS5xdWVzdGlvbm5haXJlLmNvbW1vbi52MUIYUXVlc3Rpb25uYWlyZVN0YXR1c1Byb3RvUAFaSWdpdGh1Yi5jb20vbGVtYS5haS9sZW1tYXRhL2FwaS9wcm90by9nZW4vcXVlc3Rpb25uYWlyZS9jb21tb24vdjE7Y29tbW9udjGiAgNRQ1iqAhdRdWVzdGlvbm5haXJlLkNvbW1vbi5WMcoCF1F1ZXN0aW9ubmFpcmVcQ29tbW9uXFYx4gIjUXVlc3Rpb25uYWlyZVxDb21tb25cVjFcR1BCTWV0YWRhdGHqAhlRdWVzdGlvbm5haXJlOjpDb21tb246OlYxYgZwcm90bzM");

/**
 * QuestionnaireStatus lives in its own leaf package to prevent cyclic imports
 *
 * @generated from enum questionnaire.common.v1.QuestionnaireStatus
 */
export enum QuestionnaireStatus {
  /**
   * @generated from enum value: QUESTIONNAIRE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUESTIONNAIRE_STATUS_ONGOING = 1;
   */
  ONGOING = 1,

  /**
   * @generated from enum value: QUESTIONNAIRE_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * @generated from enum value: QUESTIONNAIRE_STATUS_EXPIRED = 3;
   */
  EXPIRED = 3,

  /**
   * @generated from enum value: QUESTIONNAIRE_STATUS_DRAFT = 4;
   */
  DRAFT = 4,

  /**
   * @generated from enum value: QUESTIONNAIRE_STATUS_SUBMITTED = 5;
   */
  SUBMITTED = 5,
}

/**
 * Describes the enum questionnaire.common.v1.QuestionnaireStatus.
 */
export const QuestionnaireStatusSchema: GenEnum<QuestionnaireStatus> = /*@__PURE__*/
  enumDesc(file_questionnaire_common_v1_questionnaire_status, 0);

